






























import { computed, defineComponent, ref, watch } from '@vue/composition-api';
import { ActionSheet } from '@upc/vant';
import urlExt from '@/kits/url';
import { getAppStatus } from '@/utils/tools';

export default defineComponent({
  name: 'DrainageSheet',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    locationId: {
      type: String,
      default: ''
    }
  },
  components: { ActionSheet },
  setup(props, { emit, root }) {
    const visible = computed(() => {
      return props.value;
    });
    const isAppInstalled = ref(false);
    const titleText = computed(() =>
      isAppInstalled.value ? '即将打开大学搜题酱app，是否允许？' : '即将打开应用商店下载大学搜题酱，是否允许？'
    );
    const from = urlExt.getQuery('from');

    watch(visible, async (val: boolean) => {
      if (val) {
        isAppInstalled.value = false;
        try {
          isAppInstalled.value = await getAppStatus();
        } catch (error) {
          isAppInstalled.value = false;
        }
        root.zstrack({
          name: from === 'kd' ? 'JC6_015' : 'JC7_015',
          locationId: props.locationId
        });
      }
    });

    const onClose = (type: 'close' | 'cancel') => {
      if (type === 'close') {
        root.zstrack({
          name: from === 'kd' ? 'JC6_017' : 'JC7_017',
          locationId: props.locationId
        });
      } else if (type === 'cancel') {
        root.zstrack({
          name: from === 'kd' ? 'JC6_016' : 'JC7_016',
          locationId: props.locationId
        });
      }
      emit('input', false);
    };
    const onConfirm = () => {
      root.zstrack({
        name: from === 'kd' ? 'JC6_018' : 'JC7_018',
        locationId: props.locationId
      });
      emit('onConfirm');
    };
    return { visible, titleText, onClose, onConfirm };
  }
});
